// removed by extract-text-webpack-plugin
module.exports = {"fund-details-wrap":"fund-details-wrap___1RGdU","fund-details-button":"fund-details-button___1VKVI h2___hzLuT","dtls-tbl-row":"dtls-tbl-row___2BXSo h3___5u0xZ","dtls-tbl-lbl":"dtls-tbl-lbl___Te1we","dtls-tbl-val":"dtls-tbl-val___1r7Ma","r":"r___3Qw_v","c":"c___gcieA","cr":"cr___4COEr center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesFundDetails/TargetDateSeriesFundDetails.css
// module id = 928
// module chunks = 0